import { PORTAL_DOMAINS, docsURL } from './linkConsts';

export const GET_STARTED_VIDEO_URL = `${PORTAL_DOMAINS.copilot}/university`;
export const API_DOCS_URL = `${docsURL}/reference/quickstart`;
export const JOIN_SLACK_COMMUNITY_URL =
  'https://join.slack.com/t/copilotcommunity/shared_invite/zt-1n4u6dr8m-Bm_8Jnmq6_RoY1ySq~yVcQ';
export const PORTAL_UPDATES_URL = `${PORTAL_DOMAINS.copilot}/updates/`;
export const ENTERPRISE_INTRO_URL =
  'https://calendly.com/adamportal/enterprise-introduction';

export const SUPPORT_EMAIL = 'support@copilot.com';
export const SALES_EMAIL = 'sales@copilot.com';
